// gui/src/config/claude.ts

export const CLAUDE_MODELS = {
  // ✅ SUPPORTED MODELS (matches backend claude_config.py):
  // - fastest:  claude-haiku-4-5   (Free and above)
  // - smarter:  claude-sonnet-4-6  (Plus and above)
  // - smartest: claude-opus-4-6    (Ultra and above)
  // - uncensored: grok/grok-4-1-fast-reasoning

  // Haiku 4.5 — Fastest (all plans)
  HAIKU_4_5: 'claude-haiku-4-5',

  // Sonnet 4.6 — Smarter (Plus and above)
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',

  // Opus 4.6 — Smartest (Ultra and above)
  CLAUDE_OPUS_4_6: 'claude-opus-4-6',

  // Sonnet 4.5 — kept for compatibility
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',

  // Legacy models kept for backwards compatibility ONLY
  CLAUDE_35_SONNET: 'claude-3-5-sonnet-20240620',
  BEST: 'claude-3-opus-20240229',
  FAST: 'claude-3-sonnet-20240229',
  INSTANT: 'claude-3-haiku-20240307',
  LEGACY: 'claude-2.1',
};

// ✅ Default to Haiku 4.5 (fastest available model — free for all plans)
export const DEFAULT_CLAUDE_MODEL = 'claude-haiku-4-5';

// ✅ ONLY SUPPORTED MODELS - matches backend config
export const AVAILABLE_CLAUDE_MODELS = [
  { id: CLAUDE_MODELS.HAIKU_4_5, name: 'Claude Haiku 4.5 (Fastest)' },
  { id: CLAUDE_MODELS.CLAUDE_SONNET_4_6, name: 'Claude Sonnet 4.6 (Smarter — Plus+)' },
  { id: CLAUDE_MODELS.CLAUDE_OPUS_4_6, name: 'Claude Opus 4.6 (Smartest — Ultra+)' },
];

// Combined list of all available models (Claude + other providers)
import { AVAILABLE_VENICE_MODELS } from './venice';
import { AVAILABLE_GROK_MODELS } from './grok';

export const ALL_AVAILABLE_MODELS = [
  ...AVAILABLE_CLAUDE_MODELS,
  ...AVAILABLE_VENICE_MODELS,
  ...AVAILABLE_GROK_MODELS,
];

